import type { TFilterField, FilterValue } from '@/types/api/reports'

export type TFilterEmitValue = {
  field: TFilterField
  value: FilterValue
  is_active: boolean
}

export const addTimeToDate = ({ date_from, date_to }: { date_from: string; date_to: string }) => ({
  date_from: `${date_from}T00:00:00`,
  date_to: `${date_to}T23:59:59`,
})
